function readonly(unit) {
  return unit.map((v) => v, { skipVoid: false });
}
export {
  readonly
};
//# sourceMappingURL=readonly.mjs.map
